module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-LightItalic-3d90d74c37ef33fbebc40a2a1d4faf70.woff";